import { message } from "antd";
import React, { useRef } from "react";
import styles from "./Footer.module.scss";
interface CopyToClipboardProps {
  text: string;
}

const CopyToClipboard: React.FC<CopyToClipboardProps> = ({ text }) => {
  const textRef = useRef<HTMLDivElement>(null);

  const copyToClipboard = () => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        message.info("Text copied: " + text);
      })
      .catch((err) => {
        console.error(err);
      });
  };
  return (
    <div
      className={styles.popoverButton}
      ref={textRef}
      onClick={copyToClipboard}
      style={{ cursor: "pointer" }}
    >
      Copy
    </div>
  );
};

export default CopyToClipboard;
